import type { Store } from 'vuex'
import type { Router } from 'vue-router'
import type { I18n } from 'vue-i18n'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

/**
 * Result of useCore(). Provided by createCore() at app bootstrap.
 */
export interface UseCoreResult {
  store: Store<unknown>
  router: Router
  i18n: unknown
  /** Translate (key or key + locale). */
  t: (key: string, ...args: unknown[]) => string
  /** Translate choice (pluralization). */
  tc: (key: string, choice?: number, ...args: unknown[]) => string
  /** Translate message (with message format). */
  tm: (key: string, ...args: unknown[]) => unknown
  /** Dispatch API call via store. */
  apiCall: (...args: unknown[]) => Promise<unknown>
}

/** Commonly accessed store.state slices for typed reads without `any`. */
export type CoreStoreState = {
  business?: {
    business?: {
      id?: number
      status?: string
      location?: Record<string, unknown>
      subdomain?: string
    }
  }
  app?: {
    country?: string
    language?: string
    currentRoute?: RouteLocationNormalizedLoaded
    webView?: boolean
    appType?: string
  }
  identity?: {
    user?: {
      id?: number
      email?: string
    } | null
  }
  routingConfig?: {
    config?: Record<string, unknown> & {
      b2b_referral?: boolean
      default_currency?: string
      service_color_palettes?: Record<string, Array<{ accent: string; background: string; text: string }>>
      service_colors?: string[][]
      master?: { domain?: string }
    }
  }
  subscription?: {
    billingGlobalSettings?: Record<string, unknown>
    invoiceDetails?: { data?: { is_confirmed?: boolean } }
  }
}

export function getCoreStoreState (store: Store<unknown>): CoreStoreState {
  return store.state as CoreStoreState
}
